import { ExtendLeasesAction, LeasesActionTypes } from "./leases.actions";
import { ActionWithPayload } from "../types";
import { Action } from "@ngrx/store";
import { Lease } from "../../model";
import { GenericIdTitle } from "../../model/BaseModel";


export interface LeasesState {
  leases: Lease[],
  selectedLeaseId: number,
  types: GenericIdTitle[],
  terms: GenericIdTitle[],
  categories: GenericIdTitle[],
  paymentDue: GenericIdTitle[],
}

export const leasesInitialState: LeasesState = {
  leases: [],
  selectedLeaseId: null,
  types: [],
  terms: [],
  categories: [],
  paymentDue: []
}

export function reducer(state = leasesInitialState, action: Action): LeasesState {
  const payload = (action as ActionWithPayload<any>).payload;

  switch (action.type) {
    case LeasesActionTypes.LOAD_ALL_LEASES_SUCCESS:
      return {
        ...state,
        leases: payload.leases
      };
    case LeasesActionTypes.LOAD_LEASE_BY_ID_SUCCESS:
      let alreadyLoaded = false;
      let updatedLeases = state.leases.map(lease => {
        if (lease.id == payload.lease.id) {
          alreadyLoaded = true;
          return payload.lease;
        }
        return lease;
      });
      if (!alreadyLoaded) {
        updatedLeases.push(payload.lease);
      }
      return {
        ...state,
        leases: updatedLeases
      };
    case LeasesActionTypes.EXTEND_LEASES:
      let loadedLeases = payload.leases;
      if (state.leases.length < 1) {
        return {
          ...state,
          leases: loadedLeases
        }
      }
      return {
        ...state,
        leases: state.leases.map(lease => {
          let found = null;
          for (let loadedLease of loadedLeases) {
            if (loadedLease.id == lease.id) {
              found = loadedLease;
              break;
            }
          }
          if (!!found) {
            return found;
          }
          return lease;
        })
      };
    case LeasesActionTypes.SELECT_LEASE:
      return {
        ...state,
        selectedLeaseId: payload.leaseId
      };

    case LeasesActionTypes.SET_LEASE_TYPES:
      return {
        ...state,
        types: payload.types
      };

    case LeasesActionTypes.SET_LEASE_TERMS:
      return {
        ...state,
        terms: payload.terms
      };
    case LeasesActionTypes.SET_LEASE_CATEGORIES:
      return {
        ...state,
        categories: payload.categories
      };
    case LeasesActionTypes.SET_LEASE_PAYMENT_DUE:
      return {
        ...state,
        paymentDue: payload.paymentDue
      };
    case LeasesActionTypes.REMOVE_LEASE_SUCCESS:
      return {
        ...state,
        leases: state.leases.filter(lease => lease.id != payload.leaseId)
      };
    default:
      return state;
  }
}
